//#region index.ts
function e(e) {
	let t = e, n = [];
	return Object.freeze({
		get value() {
			return t;
		},
		update: (e) => {
			t = e instanceof Function ? e(t) : e, n?.forEach((e) => e(t));
		},
		subscribe: (e) => {
			n = [...n, e];
		},
		unsubscribe: (e) => {
			n = n.filter((t) => t !== e);
		}
	});
}
//#endregion
export { e as Observable };
